import React from 'react'
import { streamUrl } from '../api/client'
import Waveform from './Waveform'

/** Vorher = Original (amber), Nachher = Master (violet) – jeweils eigenständig abspielbar. */
const ORIGINAL_WAVE = '#f59e0b'
const ORIGINAL_PROGRESS = '#fbbf24'
const MASTER_WAVE = '#6366f1'
const MASTER_PROGRESS = '#a855f7'

/**
 * A/B-Player: Vorher (Original) und Nachher (Master) als getrennte, abspielbare Waveforms.
 * Keine überlagerte Ansicht – jeder Track hat eigene Waveform und Play-Controls.
 */
export default function ABPlayer({ trackId, hasOriginal, hasMaster }) {
  const originalUrl = trackId && hasOriginal ? streamUrl(trackId, 'original') : null
  const masterUrl = trackId && hasMaster ? streamUrl(trackId, 'wav') : null

  if (hasOriginal && hasMaster) {
    return (
      <div className="space-y-6">
        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
          <p className="mb-3 text-sm font-medium text-amber-200/90">Vorher (Original)</p>
          <Waveform
            audioUrl={originalUrl}
            height={80}
            interact
            showControls
            controlsPosition="bottom"
            waveColor={ORIGINAL_WAVE}
            progressColor={ORIGINAL_PROGRESS}
            className="w-full"
          />
        </div>
        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
          <p className="mb-3 text-sm font-medium text-violet-200/90">Nachher (Master)</p>
          <Waveform
            audioUrl={masterUrl}
            height={80}
            interact
            showControls
            controlsPosition="bottom"
            waveColor={MASTER_WAVE}
            progressColor={MASTER_PROGRESS}
            className="w-full"
          />
        </div>
      </div>
    )
  }

  const audioUrl = hasMaster ? masterUrl : hasOriginal ? originalUrl : null
  const waveColor = hasMaster ? MASTER_WAVE : ORIGINAL_WAVE
  const progressColor = hasMaster ? MASTER_PROGRESS : ORIGINAL_PROGRESS

  return (
    <div className="space-y-4">
      {audioUrl ? (
        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
          <Waveform
            audioUrl={audioUrl}
            height={140}
            interact
            showControls
            controlsPosition="left"
            waveColor={waveColor}
            progressColor={progressColor}
          />
        </div>
      ) : (
        <p className="rounded-xl border border-white/10 bg-white/5 px-4 py-8 text-center text-sm text-white/50">
          Kein Original oder Master zum Abspielen verfügbar.
        </p>
      )}
    </div>
  )
}
